import { Box, Typography } from "@mui/material";

export function PreviewError({ message = "Failed to load preview." }: { message?: string }) {
  return (
    <Box sx={{ p: 2 }}>
      <Typography color="error">{message}</Typography>
    </Box>
  );
}
